import { message } from "antd";
import { isDTRuntime } from "../dingtalk.sdk";
import { DINGTALK_AUTH_STATUS } from "../dtos/userInfo";
import { commonConfirmRender, confirmNoCancel } from "./modal";

export function showSuccessOrFailMessage(msg: string) {
    if (msg === 'SUCCESS') {
        message.success('操作成功！');
        return true;
    }
    message.error('操作失败，请稍后重试！');
    return false;
}

// Reached maximum number of subscriptions
export function subscriptionLimited(status, ret) {
    if (status === DINGTALK_AUTH_STATUS.AUTHORIZED && ret === 2500001) {
        confirmNoCancel();
        return true;
    }
    return false;
}

export function bindBeforeCreateShareLinkOrSendShareEmail<T extends Function>(eventCallback: T) {
    if (!isDTRuntime) {
        return eventCallback;
    }
    return function (...args) {
        return commonConfirmRender({
            title: "共享文件",
            content: `钉钉组织外的用户可以使用共享文件的链接查看此PDF文件或登录后添加评论，是否继续？`,
            okText: '确定'
        }).then(confirmed => {
            if (confirmed) {
                eventCallback(...args);
            }
        })
    }
}
